import { Component } from 'react';

class ComponentHelper extends Component {
	constructor(props) {
		super(props);
		this.data = {};
		this.autoBind(['observe', 'setData', 'pushChanges']);
	}

	autoBind(methods) {
		for (let i = 0; i < methods.length; i++) {
			if (this[methods[i]] && this[methods[i]].bind !== undefined) {
				this[methods[i]] = this[methods[i]].bind(this);
			} else {
				console.error('The method ' + methods[i] + ' is missing or does not exist');
			}
		}
	}

	observe(action) {
		action();
		this.pushChanges();
	}

	setData(key, value) {
		this.data[key] = value;
		this.pushChanges();
	}

	pushChanges() {
		this.setState(this.data);
	}

	autoBindAll(cmp, exclude, usingHOC) {
		const reactInternals = new Set([
			'constructor',
			'render',
			'componentWillMount',
			'componentDidMount',
			'componentWillReceiveProps',
			'shouldComponentUpdate',
			'componentWillUpdate',
			'componentDidUpdate',
			'componentWillUnmount'
		]);
		if (exclude && exclude.length > 0) {
			for (let i = 0; i < exclude.length; i++) {
				reactInternals.add(exclude[i]);
			}
		}
		let proto = cmp.__proto__;
		if (usingHOC) {
			proto = cmp.__proto__.__proto__;
		}
		for (let key of Object.getOwnPropertyNames(proto)) {
			const { value } = Object.getOwnPropertyDescriptor(proto, key);
			// do not try to bind properties and getter/setters
			if (typeof value === 'function' && !reactInternals.has(key)) {
				cmp[key] = value.bind(cmp);
			}
		}
	}
}

export default ComponentHelper;



// WEBPACK FOOTER //
// ./src/supers/ComponentHelper.js